import {addScrollDeeplinkItemAction} from 'app/modules/scrollDeeplink/actions';
import {getAnchorIdsInText} from 'app/utils/initialize/getAnchorIdsInText';

export function addLazyScroll(cId: string, text: string | undefined) {
    const hashPart = window.location.hash.substring(1);
    const anchorInText = getAnchorIdsInText(text);
    if (anchorInText.includes(hashPart) || cId === hashPart) {
        addScrollDeeplinkItemAction({cId, type: 'LAZY_SCROLL', component: 'COMPONENT_WITH_REFERENCE', reference: hashPart});
        return true;
    }

    return false;
}
